import React from "react";

import cn from "classnames";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { UserRoute } from "../../routes";

import styles from "./styles.module.scss";

export interface HttpErrorPageProps {
  code: number;
}

export const HttpErrorPage: React.FC<HttpErrorPageProps> = (props) => {
  const { code } = props;
  const { t } = useTranslation("http_error_page");

  return (
    <div className={styles.page}>
      <div className={styles.content}>
        <div className={styles.image} />
        <div className={styles.info}>
          <div className={styles.code}>{code}</div>
          <div className={styles.text}>
            {t(`${code}.text`)}{" "}
            <Link className={cn([styles.text, styles.link])} to={UserRoute.Dashboard}>
              {t("mainPage")}
            </Link>
          </div>
        </div>
        <Link className={styles.button} to={UserRoute.Dashboard}>
          {t("mainPage")}
        </Link>
      </div>
    </div>
  );
};
